module.exports = __webpack_public_path__ + "img/package.fa221d85.png";